"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useEffectCancellable = void 0;
const react_1 = require("react");
const domain_1 = require("@home-health-notify/domain");
const useEffectCancellable = (callback, deps) => {
    (0, react_1.useEffect)(() => {
        const context = new domain_1.AbortContext();
        callback(context);
        return () => context.abort();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
};
exports.useEffectCancellable = useEffectCancellable;
